const oneRFQDetailsColumns = () => {
  return (
    [
      {
        Header: 'RFQ Code',
        accessor: 'rfqCode',
        editType: 'inputField',
        options: []
      },

      {
        Header: 'Consumable Code',
        accessor: 'itemCode',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Quantity',
        accessor: 'itemCount',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Product Code',
        accessor: 'productCode',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Cost',
        accessor: 'itemCost',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Currency',
        accessor: 'currency',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Active ?',
        accessor: 'isActive',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Remarks',
        accessor: 'remarks',
        editType: 'inputField',
        options: []
      },
    ]
  )
}

export default oneRFQDetailsColumns ;
